/**
 * FIRMAMINNET — ett enda "glöm allt" som varje datalager hakar på.
 *
 * VARFÖR DEN FINNS. Tills steg 5:s lokala databas är byggd håller varje
 * datalager sin egen modulvariabel med hela firmans data i 15-30 sekunder
 * (arbetsorder-data.ts, moment-data.ts, timpriser-data.ts, tidrapport/lager.ts).
 * Utloggningen rensade valvet och sessionen men rörde inte de modulvariablerna,
 * och eftersom appen aldrig laddas om levde de vidare: nästa inloggning i SAMMA
 * FLIK och samma firma serverades föregående användares data ur minnet, utan att
 * ett enda anrop gjordes. Prislagret bar dessutom hela firmans prisbild — alla
 * timpriser, milpriset och momsen — vilket en montör aldrig ska se (beslut 16).
 *
 * REGISTRET I STÄLLET FÖR EN LISTA I session.tsx. Ett nytt datalager som glömmer
 * att lägga till sig i en handskriven lista blir en tyst läcka som ingen ser
 * förrän någon läser fel firmas siffror. Här räcker EN rad vid modulens slut:
 *
 *     registreraFirmaminne(glomPrislagret);
 *
 * NÄR DET TÖMS. Vid utloggning OCH vid firmabyte (app/session.tsx). Båda är
 * lägen där det som ligger i minnet hör till någon annan än den som nu tittar.
 * Cachen är nycklad på firmaId, så firmabytet är egentligen bara en försiktighet
 * — utloggningen är den som verkligen läcker.
 *
 * INGA IMPORTER. Modulen ska kunna läsas av vem som helst utan att dra in något,
 * och den får aldrig bli en cirkel mellan sessionen och ett datalager.
 */

const minnen = new Set<() => void>();

/**
 * Hakar på ett datalagers `glöm`-funktion. Anropas EN gång, vid modulens slut,
 * och returnerar en avregistrering för den som vill ha en (ingen behöver det i
 * dag — modulminnena lever hela appens livstid).
 */
export const registreraFirmaminne = (glom: () => void): (() => void) => {
  minnen.add(glom);
  return () => {
    minnen.delete(glom);
  };
};

/**
 * Tömmer varje registrerat modulminne. Ett lager som kastar får inte hindra de
 * andra från att tömmas — halvglömt är sämre än inget glömt alls.
 */
export const glomAllaFirmaminnen = (): void => {
  for (const glom of minnen) {
    try {
      glom();
    } catch {
      /* Ett trasigt lager ska inte lämna de övriga fulla av gammal data. */
    }
  }
};

/** Bara för test: hur många lager som hakat på. */
export const antalFirmaminnen = (): number => minnen.size;
